export const getIntialValues = (data = {}) => ({
  meta_seo: {
    meta_title: data?.meta_seo?.meta_title || "",
    meta_keyword: data?.meta_seo?.meta_keyword || "",
    meta_desc: data?.meta_seo?.meta_desc || "",
    meta_slug_url: data?.meta_seo?.meta_slug_url || "",
  },
  banner: {
    image: data?.banner?.image || "",
    heading: data?.banner?.heading || "",
    sub_heading: data?.banner?.sub_heading || "",
  },
  contact_info: {
    heading: data?.contact_info?.heading || "",
    description: data?.contact_info?.description || "",
    details: data?.contact_info?.details?.length
      ? data.contact_info.details
      : [{ type: "address", label: "", value: "", logo_img: "" }],
  },
  form: {
    heading: data?.form?.heading || "",
    button_text: data?.form?.button_text || "",
    fields: data?.form?.fields?.length
      ? data.form.fields
      : [{ name: "", placeholder: "", type: "text" }],
  },
  map: {
    url: data?.map?.url || "",
  },
  footer_bgimg: data?.footer_bgimg || "",
});

export const generatePayload = (values) => {
  const { _id, createdAt, updatedAt, __v, ...payload } = values;
  return payload;
};
